import { Component, Input } from '@angular/core';
import {
  EventPricingMatrix
} from '../../../../../../../models/event-type';
import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-event-type-pricing-matrix-details',
  templateUrl: './event-type-pricing-matrix-details.component.html',
  styleUrls: ['./event-type-pricing-matrix-details.component.css']
})
export class EventTypePricingMatrixDetailsComponent {
  @Input() matrix: EventPricingMatrix;

  constructor(
    public orgConfig: OrganizationConfigService
  ) {}
}
